import React, { forwardRef } from 'react'

import { Column } from '../column'
import { useSettings } from './hooks'

import { ContentProps, ContentTypeName } from './content.types'
import { useStyle } from './content.styles'

export const MEDIUM_SCREEN_WIDTH = 1600

export const Content = forwardRef<HTMLDivElement, ContentProps>(
  ({ className, children, preset = ContentTypeName.extraLarge }, ref) => {
    const { alignedPreset } = useSettings({
      preset
    })

    const classes = useStyle()
    const { [alignedPreset]: modifier } = classes

    return (
      <Column
        ref={ref}
        className={`${className} ${classes.container} ${modifier}`}
        justifyContent="flex-start"
      >
        {children}
      </Column>
    )
  }
)
